import { useTranslation } from 'react-i18next';
import { baseLang } from '../i18n/index.js';

export function Impressum() {
  const { t, i18n } = useTranslation();
  const showNotice = baseLang(i18n.language) !== 'de';
  return (
    <div className="card card-wide">
      {showNotice && <div className="alert alert-info">{t('legalNotice.deAuthoritative')}</div>}
      <h2 className="card-title">Impressum</h2>

      <h3 className="legal-h">Angaben gemäß § 5 DDG</h3>
      <p>
        GQL Gussone Quecke Legal<br />
        Partnerschaft von Rechtsanwälten mbB<br />
        Rubensstraße 114<br />
        12157 Berlin
      </p>
      <p>
        Hauptkanzlei (Sitz der Partnerschaft):<br />
        Strausberger Platz 19<br />
        10243 Berlin
      </p>
      <p>
        <strong>Partnerschaftsregister:</strong> Amtsgericht Charlottenburg, PR 1615<br />
        <strong>Umsatzsteuer-Identifikationsnummer:</strong> DE34758135
      </p>

      <h3 className="legal-h">Vertretungsberechtigte Partner</h3>
      <p>
        Rechtsanwalt Dr. Peter Gussone<br />
        Rechtsanwalt Moritz Quecke
      </p>

      <h3 className="legal-h">Kontakt</h3>
      <p>
        Telefon: +49 30 9151 9940<br />
        Telefax: +49 30 3771 9678<br />
        E-Mail: <a href="mailto:info@gql-partner.de">info@gql-partner.de</a><br />
        Web: <a href="https://www.gql-partner.de" target="_blank" rel="noreferrer">www.gql-partner.de</a>
      </p>

      <h3 className="legal-h">Berufsbezeichnung und berufsrechtliche Regelungen</h3>
      <p>
        <strong>Berufsbezeichnung:</strong> Rechtsanwalt (verliehen in der Bundesrepublik Deutschland)<br />
        <strong>Zuständige Anwaltskammer:</strong> Rechtsanwaltskammer Berlin, Littenstraße 9, 10179 Berlin, Telefon 030/30 69 31 0 (<a href="https://www.rak-berlin.de" target="_blank" rel="noreferrer">www.rak-berlin.de</a>)<br />
        <strong>Berufsrechtliche Regelungen:</strong> Bundesrechtsanwaltsordnung (BRAO), Berufsordnung für Rechtsanwälte (BORA), Fachanwaltsordnung (FAO), Rechtsanwaltsvergütungsgesetz (RVG), Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE). Einsehbar unter <a href="https://www.brak.de" target="_blank" rel="noreferrer">www.brak.de</a> → Berufsrecht.
      </p>

      <h3 className="legal-h">Berufshaftpflichtversicherung</h3>
      <p>
        <strong>Versicherer:</strong> Nürnberger Allgemeine Versicherung AG, Ostendstraße 100, 90334 Nürnberg
      </p>
      <p>
        <strong>Räumlicher Geltungsbereich:</strong> Die Berufshaftpflichtversicherung
        umfasst die weltweite Tätigkeit für europäisches Recht, Recht der Türkei sowie
        außereuropäischer Hoheitsgebiete der EU/EWR-Staaten, einschließlich Tätigkeiten
        vor europäischen Gerichten und Gerichten der genannten Hoheitsgebiete. Eine
        weltweite Inanspruchnahme für Beratung im europäischen Recht ist eingeschlossen
        (Tätigkeit vor außereuropäischen Gerichten nur bis zur Mindestversicherungssumme
        nach § 51 BRAO). Die Mindestversicherungssumme nach § 51 BRAO wird eingehalten.
      </p>

      <h3 className="legal-h">Streitbeilegung</h3>
      <p>
        Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen (§ 36 Abs. 1 Nr. 1 VSBG).
        Für die außergerichtliche Beilegung von Streitigkeiten zwischen Rechtsanwälten und
        ihren Mandanten besteht auf Antrag die Schlichtungsstelle der Rechtsanwaltschaft
        bei der Bundesrechtsanwaltskammer (<a href="https://www.s-d-r.org" target="_blank" rel="noreferrer">www.s-d-r.org</a>).
      </p>

      <h3 className="legal-h">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
      <p>
        Rechtsanwalt Moritz Quecke<br />
        Rubensstraße 114, 12157 Berlin
      </p>
    </div>
  );
}
